import { FC } from 'react'
import {
  StyleCard,
  StyleCardHeader,
  StyleLeftCardHeader,
  StyleRightCardHeader,
  StyleTag,
} from './style'
import Image from '@components/image'
import Column from '@components/column'
import Typography from '@components/typography'
import ScheduleCard from '../schedule'
interface AppointmentScheduleProps {
  styleCard?: string
  appointment?: any
  hasView?: boolean
}
const AppointmentSchedule: FC<AppointmentScheduleProps> = ({
  styleCard,
  appointment,
}) => {
  return (
    <StyleCard
      styleCard={styleCard}
      data-cross-type={`view-${appointment?.id}`}
    >
      <StyleCardHeader>
        <StyleLeftCardHeader>
          <Image
            src={`${process.env.BUCKET_URL}/${appointment?.patient?.avatar}`}
            styleImage="border-radius:50%;"
            width={50}
            height={50}
            fallbackType="user"
          />
          <Column rowGap={10}>
            <Typography
              content={appointment?.patient?.name}
              size={14}
              tc="text"
            />
          </Column>
        </StyleLeftCardHeader>
        <StyleRightCardHeader>
          <StyleTag>
            {appointment?.infos?.appointmentType == 'At Clinic'
              ? 'At Clinic'
              : 'Online'}
          </StyleTag>
        </StyleRightCardHeader>
      </StyleCardHeader>
      <ScheduleCard date={appointment?.date} />
    </StyleCard>
  )
}

export default AppointmentSchedule
